import * as React from 'react';
import { Callout, DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import { InfoBarCalloutAction } from '../schema/InfoBarMessageViewState';

export interface InfoBarMessageWithCalloutActionProps extends InfoBarCalloutAction {
    className?: string;
}

interface InfoBarMessageWithCalloutActionState {
    isCalloutVisible: boolean;
}

export class InfoBarMessageWithCustomAction extends React.Component<
    InfoBarMessageWithCalloutActionProps,
    InfoBarMessageWithCalloutActionState
> {
    private linkRef: HTMLElement;

    constructor(props: InfoBarMessageWithCalloutActionProps) {
        super(props);

        this.state = {
            isCalloutVisible: false,
        };
    }

    private onLinkClicked = (evt: React.MouseEvent<Element>): void => {
        evt.stopPropagation();
        this.setState({
            isCalloutVisible: !this.state.isCalloutVisible,
        });
    };

    private onCalloutDismiss = (): void => {
        this.setState({
            isCalloutVisible: false,
        });
    };

    private onLinkRef = (ref: HTMLAnchorElement) => {
        this.linkRef = ref;
    };

    render() {
        return (
            <>
                <a
                    href={'javascript:void(0);'}
                    className={this.props.className}
                    onClick={this.onLinkClicked}
                    ref={this.onLinkRef}>
                    {this.props.text}
                </a>
                <Callout
                    target={this.linkRef}
                    directionalHint={DirectionalHint.rightTopEdge}
                    calloutMaxWidth={this.props.maxWidth}
                    onDismiss={this.onCalloutDismiss}
                    hidden={!this.state.isCalloutVisible}>
                    {this.props.calloutContent}
                </Callout>
            </>
        );
    }
}

export default InfoBarMessageWithCustomAction;
